import React from 'react';
import {useAppSelector} from '../../../../../../hooks/hooks';
import Box from '@mui/material/Box';
import {FilterState} from './types';
import VacationFilterListPopup from '../property-filter-popup';
import { REmployees } from '../../../../../../features/roles/types';

interface Props {
    onChange: (state: FilterState) => Promise<void>;
    hasSelected: boolean;
    className?: string;
    disabled?: boolean;
    compactNarrowDesktop?: boolean;
    employees?: REmployees[];
    disableEmployeesFilter?: boolean;
}

const VacationReportFilter = (props: Props) => {
    const storeEmployees = useAppSelector((selector) => selector.rEmployees);
    const employees = props.employees ?? storeEmployees;

    return (
        <Box display={'flex'} gap={2} height={'100%'} className={props.className}>
            <VacationFilterListPopup
                employees={employees}
                hasSelected={props.hasSelected}
                onChange={props.onChange}
                disabled={props.disabled}
                compactNarrowDesktop={props.compactNarrowDesktop}
                disableEmployeesFilter={props.disableEmployeesFilter}
            />
        </Box>
    );
};

export default React.memo(VacationReportFilter);
